import React, { Component } from "react";
import { Growl } from "primereact/growl";
import { Messages } from "primereact/messages";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subMonths from "date-fns/subMonths";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { SelectButton } from "primereact/selectbutton";
import * as appConst from "../../Common/constants";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";

const GENDER_OPTIONS_LIST = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" }
];

class PatientAddEdit extends Component {
  constructor(props) {
    super(props);

    var _pno,
      _pno,
      _name,
      _age,
      _address,
      _gender,
      _phone,
      _regdate,
      _mode

    if (this.props.pData._id === "NA") {
      _pno = "";
      _name = "";
      _age = "";
      _address = "";
      _gender = "";
      _phone = "";
      _regdate = null;
      _mode = "add";
    } else {
      _pno = this.props.pData.pno;
      _name = this.props.pData.name;
      _age = this.props.pData.age;
      _address = this.props.pData.address;
      _gender = this.props.pData.gender;
      _phone = this.props.pData.phone;

      _regdate =
        typeof this.props.pData.regdate === "undefined" ||
          this.props.pData.regdate === "" ||
          this.props.pData.regdate === null ||
          this.props.pData.regdate.startsWith("0001")
          ? null
          : new Date(this.props.pData.regdate);

      _mode = "edit";
    }

    this.state = {
      pno: _pno,
      name: _name,
      age: _age,
      address: _address,
      gender: _gender,
      phone: _phone,
      regdate: _regdate,
      spinnerClass: "collapse",
      dataClass: "",
      mode: _mode,
      patients: []
    };

    this.handleRegDateChange = this.handleRegDateChange.bind(this);
  }

  componentDidMount() {
    this.showBusy(true);
    this.showBusy(false);
    this.LoadRegNo();
  }

  LoadRegNo() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/RegNo"
      )
      .then(response => {
        this.setState({ pno: response.data });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  showBusy(mode) {
    if (mode === true) {
      this.setState({ spinnerClass: "", dataClass: "collapse" });
    } else {
      this.setState({ spinnerClass: "collapse", dataClass: "" });
    }
  }

  render() {
    return (
      <div>
        <h5 align="center"> {this.getHeading()}</h5>
        <div className="row">
          <div className="col col-md-6">
            <div className="container-fluid">
              <div className="row p-1 border">
                <div className="col col-md-3 ">Reg No</div>
                <div className="col col-md-3">
                  <InputText
                    type="text"
                    value={this.state.pno}
                    onChange={e => this.setState({ pno: e.target.value.replace("/", "-") })}
                    style={{ width: "150px" }}
                    className="p-error"
                  />
                </div>
              </div>
              <div className="row p-1 border">
                <div className="col col-md-3">Reg Date</div>
                <div className="col col-md-3">
                  <DatePicker
                    selected={this.state.regdate}
                    onChange={this.handleRegDateChange}
                    dateFormatCalendar={"MMM yyyy"}
                    minDate={subMonths(new Date(), 24)}
                    maxDate={new Date()}
                    showMonthYearDropdown
                    dateFormat="dd-MMM-yyyy"
                    width="300px"
                  />
                </div>
              </div>

              <div className="row p-1 border">
                <div className="col col-md-3">Name</div>
                <div className="col col-md-3">
                  <InputText
                    type="text"
                    value={this.state.name}
                    onChange={e => this.setState({ name: e.target.value })}
                    style={{ width: "300px" }}
                    className="p-error"
                  />
                </div>
              </div>
              <div className="row p-1 border">
                <div className="col col-md-3">Age</div>
                <div className="col col-md-3">
                  <InputText
                    type="text"
                    keyfilter="money"
                    value={this.state.age}
                    onChange={e => this.setState({ age: e.target.value })}
                    style={{ width: "300px" }}
                    className="p-error"
                  />
                </div>
              </div>
              <div className="row p-1 border">
                <div className="col col-md-3">Gender</div>
                <div className="col col-md-6">
                  <SelectButton
                    value={this.state.gender}
                    options={GENDER_OPTIONS_LIST}
                    onChange={e => this.setState({ gender: e.value })}
                    className="p-error"
                  />
                </div>
              </div>
              <div className="row p-1 border">
                <div className="col col-md-3">Phone</div>
                <div className="col col-md-3" onBlur={this.onPhoneComplete} >
                  <InputText
                    type="text"
                    value={this.state.phone}
                    onChange={e => this.setState({ phone: e.target.value })}
                    style={{ width: "300px" }}
                  />
                </div>
              </div>
              <div className="row p-1 border">
                <div className="col col-md-3">Address</div>
                <div className="col col-md-3">
                  <InputTextarea
                    rows={5}
                    cols={37}
                    value={this.state.address}
                    onChange={e => this.setState({ address: e.target.value })}
                    autoResize={true}
                  />
                </div>
              </div>

              <div className="row p-1 border">
                <button
                  onClick={this.onAddClick}
                  className="btn btn-primary btn-md mr-2"
                >
                  Save
                </button>
                <button
                  onClick={this.onClearClick}
                  className="btn btn-primary btn-md mr-2"
                >
                  Clear
                </button>
                <button
                  onClick={this.onCancelClick}
                  className={this.getCancelClass()}
                >
                  Cancel
                </button>
              </div>
              <Growl ref={el => (this.growl = el)} />
              <Messages ref={el => (this.messages = el)} />
            </div>

          </div>
          <div className="col col-md-6">
            <div className="ag-theme-blue" style={this.getHeight()}>
              <AgGridReact
                rowData={this.state.patients}
                pagination={true}
                enableSorting={true}
                enableFilter={true}
                onGridReady={this.onGridReady}
                paginationAutoPageSize={true}
              >
                <AgGridColumn
                  field="pno"
                  headerName="Reg #"
                  width={100}
                  sortable
                  resizable
                  filter
                />
                <AgGridColumn
                  field="name"
                  headerName="Name"
                  width={200}
                  sortable
                  resizable
                  filter
                />
                <AgGridColumn
                  field="age"
                  headerName="Age"
                  width={100}
                  sortable
                  resizable
                  filter
                />
                <AgGridColumn
                  field="regdate"
                  headerName="Reg Date"
                  width={120}
                  sortable
                  resizable
                  filter
                  valueFormatter={this.dateFormatter}
                />
              </AgGridReact>
            </div>

          </div>
        </div>
      </div>
    );
  }

  dateFormatter(params) {
    var arr = params.value.split("-");
    return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
  }

  onPhoneComplete = e => {

    let obj = {
      status: "Phone",
      searchText: this.state.phone
    };

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/patientFilter/",
        obj
      )
      .then(res => {
        this.setState({ patients: res.data });
      });

  };

  handleRegDateChange(date) {
    this.setState({ regdate: date });
  }

  getCancelClass() {
    let clsName = "btn btn-primary btn-md mr-2 ";
    if (this.props.source === "list") {
      clsName += "visible";
    } else {
      clsName += "invisible";
    }
    return clsName;
  }

  getHeight() {
    var hgt = window.innerHeight - 275;
    return { height: hgt + "px" };
  }


  getHeading() {
    if (this.state.mode === "add") {
      return "Add New Patient";
    } else {
      return (
        "Edit Patient Reg No : " + this.state.pno
      );
    }
  }

  getPnoAddClass() {
    let clsName = "col col-md-3 ";
    if (this.state.mode === "edit") clsName = "collapse";
    return clsName;
  }

  getPnoEditClass() {
    let clsName = "col col-md-3 ";
    if (this.state.mode === "add") clsName = "collapse";
    return clsName;
  }

  onAddClick = e => {
    e.preventDefault();

    if (
      this.state.name === "" ||
      this.state.age === "" ||
      this.state.gender === "" ||
      this.state.pno === ""
    ) {
      this.messages.show({
        severity: "error",
        summary: "Error !!",
        detail: "Select Mandatory Fields"
      });
    } else {
      const obj = {
        pno: this.state.pno,
        name: this.state.name,
        age: this.state.age,
        address: this.state.address,
        gender: this.state.gender,
        phone: this.state.phone,
        regdate: this.state.regdate
      };

      if (this.state.mode === "add") {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
            "/patient/add",
            obj
          )
          .then(res => {
            if (res.status === 200) {
              this.ClearData();
              this.growl.show({
                severity: "success",
                summary: "Success",
                detail: "Patient Added !!!"
              });
            } else if (res.status === 204) {
              this.growl.show({
                severity: "error",
                summary: "Error !!",
                detail: "Registration number already exists !!"
              });
            }
          });
      } else {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +

            "/patient/update/" +
            this.props.pData._id,
            obj
          )
          .then(res => {
            if (res.status === 200) {
              this.props.onClick("List", null);
            } else if (res.status === 204) {
              this.growl.show({
                severity: "error",
                summary: "Error !!",
                detail: "Registration number already exists !!"
              });
            }
          });
      }
    }
  };

  toggleValidating(validate) {
    this.setState({ validate });
  }

  ClearData() {
    this.setState({
      pno: "",
      name: "",
      age: "",
      address: "",
      gender: "",
      phone: "",
      regdate: "",
    });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}

export default PatientAddEdit;
